import React from "react";
import { motion, useReducedMotion } from "framer-motion";

// Offsets are expressed as the *starting* position relative to rest (0,0) —
// "left"/"right" describe the direction content visibly travels FROM as it
// settles into place, matching how the effect reads to someone scrolling.
const OFFSETS = {
  up: { x: 0, y: 36 },
  down: { x: 0, y: -36 },
  left: { x: -56, y: 0 },
  right: { x: 56, y: 0 },
  fade: { x: 0, y: 0 },
};

const EASE = [0.22, 1, 0.36, 1];

const Reveal = ({
  children,
  direction = "up",
  delay = 0,
  duration = 0.65,
  amount = 0.2,
  once = true,
  as = "div",
  className,
  ...rest
}) => {
  const prefersReducedMotion = useReducedMotion();
  const offset = OFFSETS[direction] || OFFSETS.up;

  if (prefersReducedMotion) {
    const Tag = as;
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  const MotionTag = motion[as] || motion.div;

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, x: offset.x, y: offset.y }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
